export default __webpack_public_path__ + "static/media/share.44b26367.svg";